export const DEFAULT_AI_PROVIDER = 'ANTHROPIC';
export const DEFAULT_AI_MODEL = 'claude-haiku-4-5';
